import { useEffect, useRef } from "react";
import { arrayOf, bool, shape, string } from "prop-types";
import { indicatorDataShape } from "../../../../Common/js/common/datacenterData.js";
import { downloadFile } from "../../../../Common/js/common/download.js";
import topic_page_world_map, {
  filterMapData,
} from "./legacy/topic_page_world_map.js";
import transformDatacenterData from "./transformDatacenterData.js";
import Button from "../Button/Button.jsx";
import Icon from "../Icon/Icon.jsx";
import slugify from "slugify";
import Canvg from "canvg";

import { csvFormat } from "d3-dsv";

/*
 from http://carhlsdev402.westus.cloudapp.azure.com/stunting/
 */

const propTypes = {
  title: string,
  description: string,
  source: string,
  highlightYear: string, // yyyy
  showMostRecent: bool,
  results: shape({
    data: arrayOf(indicatorDataShape).isRequired,
    errorMessage: string,
  }),
};

const TopicFeatureMap = (props) => {
  const { highlightYear, showMostRecent, title, source, description } = props;
  const data = props.results.data[0]; // there will always only be 1 dataset

  const svgRef = useRef();
  const svgContainerRef = useRef();
  const tooltipSvgRef = useRef();
  const mapData = transformDatacenterData(data); // was stuntingData
  const mapIndicatorData = data.indicator;
  const mapLocationData = data.locations;
  const mapDataType = data.dataType;

  useEffect(() => {
    topic_page_world_map({
      svgEl: svgRef.current,
      toolTipSvgEl: tooltipSvgRef.current,
      mapData,
      mapIndicatorData,
      mapLocationData,
      mapDataType,
      year: Number(highlightYear),
      showMostRecent: showMostRecent,
    });
  }, [
    highlightYear,
    mapData,
    mapDataType,
    mapLocationData,
    mapIndicatorData,
    showMostRecent,
  ]);

  const filename =
    slugify(title || "map") + (highlightYear ? `-${highlightYear}` : "");

  const handleImageDownloadClick = (e) => {
    // Solution sources:
    // 1. https://stackoverflow.com/questions/29888050/outerhtml-returns-undefined-for-svg-elements-in-ie#answer-44943988
    // 2. https://stackoverflow.com/questions/15360918/xml5619-incorrect-document-syntax-error-in-ie10-only
    // 3. https://github.com/niklasvh/html2canvas/issues/1472

    const canvas = document.createElement("canvas");
    const svg = svgContainerRef.current.querySelector("svg");
    const svgString = new XMLSerializer().serializeToString(svg); // prefer this instead of `const svgString = svg.outerHTML;` to avoid XML parsing errors.
    const ctx = canvas.getContext("2d");

    const v = Canvg.fromString(ctx, svgString);
    v.start();

    downloadFile(`${filename}.png`, canvas.toDataURL("image/png"));
  };

  const handleDataDownloadClick = (e) => {
    //downloadCsv(`${filename}.csv`, csvFormat(topicFeatureMapData));
    const mapDataToDownload = filterMapData(
      mapData,
      parseInt(highlightYear, 10),
      showMostRecent,
    );
    downloadCsv(`${filename}.csv`, csvFormat(mapDataToDownload));
  };

  return (
    <div className="topic-feature-map">
      <div className="topic-feature-map__header">
        <div className="topic-feature-map__header-title">
          {title && <div className="topic-feature-map__title">{title}</div>}
          {description && (
            <div className="topic-feature-map__description">{description}</div>
          )}
        </div>
        <div className="topic-feature-map__buttons">
          <Button
            className="btn--tertiary-ghost"
            icon={<Icon iconName="download" />}
            onClick={handleImageDownloadClick}
          >
            Image
          </Button>
          <Button
            className="btn--tertiary-ghost"
            icon={<Icon iconName="download" />}
            onClick={handleDataDownloadClick}
          >
            Data
          </Button>
        </div>
      </div>
      <div ref={svgContainerRef} className="topic-feature-map__map-container">
        <svg ref={svgRef} width={960} height={432} />
      </div>
      {source && <div className="topic-feature-map__source">{source}</div>}
    </div>
  );
};

TopicFeatureMap.propTypes = propTypes;
export default TopicFeatureMap;

// Source: https://ourcodeworld.com/articles/read/189/how-to-create-a-file-and-generate-a-download-with-javascript-in-the-browser-without-a-server
function downloadCsv(filename, text) {
  downloadFile(
    filename,
    "data:text/plain;charset=utf-8," + encodeURIComponent(text),
  );
}
